import React from 'react';
import './style.sass';
import { Link } from 'react-router-dom';
import { useIsMobile } from 'hooks/useIsMobile';

export default function ErrorSearchServices({ ...params }) {
    const { searchQ, suggestion } = params;
    const { isMobile } = useIsMobile();

    return (
        <div className="errorSearchServices">
            <div className="boxCopys">
                <p className="titleError">No se encontraron resultados para <span>"{searchQ}"</span></p>
                <p className="titleRevisar">Revisa la ortografía o intenta con términos genéricos</p>
            </div>
            
            <div className="genericResultError">
                <ul className="opcionesBusqueda">
                    <li> <Link to="/categoria" title="categorias" className="icoCategoria">Buscar por categoría</Link></li>
                    <li> <Link to="/tiendas" title="tiendas oficiales" className="icoTienda">Buscar en Tiendas Oficiales</Link></li>
                </ul>
            </div>
        </div>
    )
}